export { default } from 'components/Loading/Spinner'
export * from 'components/Loading/Spinner'
